export const commonColumns = [
  {
    headTitle: 'Name',
    field: 'name'
  }
]
